import { type RouteRecordRaw } from 'vue-router';

import { License } from '../../models';

export const digitalSignageRoutes: RouteRecordRaw[] = [{
    path: 'digital-signage/content',
    name: 'content',
    redirect: { name: 'content.loops' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 2,
        index: 1,
        licenses: {
            operator: 'and',
            licenses: [License.SPOT_VIDEO]
        },
        prependIcon: 'icon-wireless',
        code: 'playdoo.routes.menu.content'
    },
    component: () => import('./views/ContentView.vue'),
    children: [{
        path: 'loops/:loopId',
        name: 'content.loop',
        meta: {
            index: 0,
            code: 'playdoo.routes.content.loop',
            breadcrumbs: true
        },
        component: () => import('./views/content/LoopView.vue')
    }, {
        path: 'children/:loopId',
        name: 'content.children-loop',
        meta: {
            index: 0,
            code: 'playdoo.routes.content.children-loop',
            breadcrumbs: true
        },
        component: () => import('./views/content/ChildrenLoopView.vue')
    }, {
        path: 'loops',
        name: 'content.loops',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'playdoo.routes.content.loops',
            query: ['scopeToggle']
        },
        component: () => import('./views/content/LoopsView.vue')
    }, {
        path: 'shared/:loopId',
        name: 'content.shared-loop',
        meta: {
            index: 1,
            code: 'playdoo.routes.content.shared-loop',
            breadcrumbs: true
        },
        component: () => import('./views/content/SharedLoopView.vue')
    }, {
        path: 'shared',
        name: 'content.shared',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'playdoo.routes.content.shared',
            query: ['loopToggle']
        },
        component: () => import('./views/content/SharedView.vue')
    }, {
        path: 'favorites',
        name: 'content.favorites',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'playdoo.routes.content.favorites',
            query: ['loopToggle']
        },
        component: () => import('./views/content/FavoritesView.vue')
    }, {
        path: 'media',
        name: 'content.media',
        meta: {
            showInTabs: true,
            index: 3,
            code: 'playdoo.routes.content.media',
            query: ['scopeToggle']
        },
        component: () => import('./views/content/MediaView.vue')
    }]
}, {
    path: 'digital-signage/studio',
    name: 'studio',
    redirect: { name: 'studio.designs' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 2,
        index: 2,
        licenses: {
            operator: 'and',
            licenses: [License.SPOT_VIDEO]
        },
        prependIcon: 'icon-template',
        code: 'playdoo.routes.menu.studio'
    },
    component: () => import('./views/StudioView.vue'),
    children: [{
        path: 'designs',
        name: 'studio.designs',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'playdoo.routes.studio.designs',
            query: ['scopeToggle']
        },
        component: () => import('./views/studio/DesignsView.vue')
    }, {
        path: 'explore/:curationCategoryId/curations/:curationId',
        name: 'studio.explore.curation-category.curation',
        meta: {
            index: 1,
            code: 'playdoo.routes.studio.explore-curation',
            breadcrumbs: true
        },
        component: () => import('./views/studio/ExploreCurationView.vue')
    }, {
        path: 'explore/:curationCategoryId',
        name: 'studio.explore.curation-category',
        meta: {
            index: 1,
            code: 'playdoo.routes.studio.explore-category',
            breadcrumbs: true
        },
        component: () => import('./views/studio/ExploreCategoryView.vue')
    }, {
        path: 'explore',
        name: 'studio.explore',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'playdoo.routes.studio.explore'
        },
        component: () => import('./views/studio/ExploreView.vue')
    }, {
        path: 'catalog',
        name: 'studio.catalog',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'playdoo.routes.studio.catalog'
        },
        component: () => import('./views/studio/CatalogView.vue')
    }, {
        path: 'files',
        name: 'studio.files',
        meta: {
            showInTabs: true,
            index: 3,
            code: 'playdoo.routes.studio.files',
            query: ['scopeToggle']
        },
        component: () => import('./views/studio/FilesView.vue')
    }]
}, {
    path: 'digital-signage/studio/designs/:designId',
    name: 'studio.design',
    meta: {
        code: 'playdoo.routes.studio.design',
        hideNavigationMenu: true,
        alterApplicationBar: true
    },
    component: () => import('./views/studio/DesignView.vue')
}];